import React, { useState } from "react";
import { createLinkedTodo, postComptaStageForm, finalizeComptaStage } from "./comptaStageHelpers";
import NotifyPicker from "./NotifyPicker";
import { CommentField, ReadField, SubmitBar } from "./FormFields";
import { cardCls, labelCls, inputCls } from "./formStyles";

// Étape 1/5 — Arrivée PC. Formulaire si pas encore rempli (showFormInstead),
// sinon résumé en lecture seule (tache.arrivePCForm).
function ArrivePCStage({
  tache,
  showFormInstead,
  selectedClient,
  selectedYear,
  selectedMonth,
  refetch,
  setShowOverlay,
  allUsers,
  utilisateur,
}) {
  const [formData, setFormData] = useState({ dateEffet: "", commentaire: "", userIds: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // 1. Création de la tâche (ToDo) — échec ici => on relance (comme l'origine).
      const todoId = await createLinkedTodo({
        title: "Tri et numérisation - Suivi Compta",
        selectedClient,
        userIds: [39],
        commentaire: formData.commentaire,
        rethrowOnError: true,
      });

      // 2. Envoi du payload avec l'ID du ToDo créé
      const payload = {
        dateEffet: formData.dateEffet,
        commentaire: formData.commentaire,
        assignedTo: formData.userIds.join(","),
        TodoCreate: todoId,
      };

      const tacheId = await postComptaStageForm({
        clientId: selectedClient.id,
        year: selectedYear,
        month: selectedMonth,
        stage: "arrivePC",
        payload,
        tacheIdErrorMessage: "tacheId introuvable dans la réponse.",
      });

      const emailArrivePayload = {
        NomComplet: `${utilisateur.lastName} ${utilisateur.name}`,
        datedEffet: formData.dateEffet,
        commentaire: formData.commentaire,
        userEmails: formData.userIds,
      };
      const clientIdArrive = selectedClient.id;

      // ✅ Fermer l'overlay immédiatement après le POST principal
      setLoading(false);
      setShowOverlay(false);
      setSuccess(true);
      setFormData({ dateEffet: "", commentaire: "", userIds: [] });

      // 🔄 Opérations secondaires en arrière-plan
      finalizeComptaStage({
        clientId: clientIdArrive,
        tacheId,
        emailEndpoint: "https://backend-myalfa.vercel.app/api/email-arrivepc",
        emailPayload: emailArrivePayload,
        prevTodoEndpoint: null,
        refetch,
      });
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      {showFormInstead && (
        <form
          className={cardCls}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(tache.id);
          }}
        >
          <p className="text-sm font-bold text-[#5C1A30]">1 / Arrivé PC</p>

          <div>
            <label className={labelCls}>Date</label>
            <input
              type="datetime-local"
              value={formData.dateEffet}
              onChange={(e) => setFormData({ ...formData, dateEffet: e.target.value })}
              required
              className={inputCls}
            />
          </div>

          <CommentField
            value={formData.commentaire}
            onChange={(e) => setFormData({ ...formData, commentaire: e.target.value })}
          />

          <NotifyPicker allUsers={allUsers} formData={formData} setFormData={setFormData} />

          <SubmitBar loading={loading} error={error} success={success} />
        </form>
      )}

      {tache.arrivePCForm && (
        <div className={cardCls}>
          <ReadField
            label="Date effet"
            value={new Date(tache.arrivePCForm.dateEffet).toLocaleString()}
          />
          <ReadField label="Commentaire" value={tache.arrivePCForm.commentaire} />
          <ReadField
            label="Date de création"
            value={new Date(tache.arrivePCForm.createdAt).toLocaleString()}
          />
        </div>
      )}
    </>
  );
}

export default ArrivePCStage;
